import { createContext } from 'react';

const LanguageContext = createContext({ selectedLanguage: 'en-US', setSelectedLanguage: null });

export default LanguageContext;